import React from 'react';
import { Eye, Pencil } from 'lucide-react';
import { openEditor } from '@/lib/openEditor';

/**
 * After a site is built: open it, edit it. No copy-paste of a URL.
 */
export default function WebsiteReadyActions({ website, size = 'md', testIdPrefix = 'site', openTestId, editTestId }) {
  if (!website) return null;
  const siteUrl = (website.site_url || '').trim();
  const canEdit = Boolean(website.id);
  const large = size === 'lg';
  const primary = large
    ? 'inline-flex items-center justify-center gap-2 bg-indigo-500 hover:bg-indigo-600 text-white px-5 py-3 rounded-xl text-sm font-medium shadow-lg shadow-indigo-500/20'
    : 'inline-flex items-center justify-center gap-2 bg-indigo-500 hover:bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm font-medium';
  const secondary = large
    ? 'inline-flex items-center justify-center gap-2 bg-slate-800 hover:bg-slate-700 text-white px-5 py-3 rounded-xl text-sm font-medium border border-slate-600'
    : 'inline-flex items-center justify-center gap-2 bg-slate-800 hover:bg-slate-700 text-slate-100 px-4 py-2 rounded-lg text-sm font-medium border border-slate-700';

  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testIdPrefix}-ready-actions`}>
      {siteUrl ? (
        <a
          href={siteUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={primary}
          data-testid={openTestId || `${testIdPrefix}-open-site`}
        >
          <Eye className={large ? 'w-4 h-4' : 'w-4 h-4'} />
          Open website
        </a>
      ) : null}
      {canEdit ? (
        <button
          type="button"
          onClick={() => openEditor(website, website.edit_url || siteUrl)}
          className={siteUrl ? secondary : primary}
          data-testid={editTestId || `${testIdPrefix}-edit-site`}
        >
          <Pencil className="w-4 h-4" />
          Edit this website
        </button>
      ) : null}
    </div>
  );
}
